import { registerPlugin } from "@capacitor/core"

import type { FilePathPlugin } from "./definitions"

const FilePath = registerPlugin<FilePathPlugin>("FilePath")

export type * from "./definitions"
export { FilePath }
